/* globals Mmenu */

import enquire from 'enquire.js'
import 'mmenu-js/dist/mmenu.js'
import 'mmenu-js/dist/mmenu.css'

Drupal.behaviors.AutryHamburger = {
  divider: function () {
    const Divider = document.createElement('li')
    Divider.classList.add('Divider')
    return Divider
  },

  attach: function (context, settings) {
    const elements = once('AutryHamburger', '.mmenu-toggle')

    elements.forEach(trigger => {
      // console.log(trigger)
      enquire.register('screen and (max-width : 1239px)', {
        deferSetup: true,
        setup: () => {
          const block = document.getElementById('block-sitemap')
          if (block) {
            trigger.setAttribute('aria-controls', 'autry-mobile-menu')

            // create a "clean" clone of the footer menu
            const clone = block.cloneNode(true)
            clone.setAttribute('id', 'autry-mobile-menu')
            clone.setAttribute('aria-label', 'Mobile Menu')
            clone.removeAttribute('class')

            const tree = clone.querySelector('.menu--sitemap')

            // any link-less parents are useless
            // copy the children into the mobile menu tree
            tree.querySelectorAll('span').forEach(el => {
              Array.from(el.nextSibling.children).forEach(ele =>
                tree.appendChild(ele)
              )
              el.parentElement.remove()
            })

            // copy the Utility menu items into the mobile menu tree
            const utility = block.querySelector('.menu--utility')
            tree.appendChild(this.divider())
            Array.from(utility.children).forEach(ele => tree.appendChild(ele))

            // copy the Call to Action menu items into the mobile menu tree
            // const cta = block.querySelector('.menu--cta')
            // tree.appendChild(this.divider())
            // Array.from(cta.children).forEach(ele => tree.appendChild(ele))

            // remove the extra items wrapper & menus
            clone.querySelector('.sitemap-mobile-extra').remove()

            this.mmenu = new Mmenu(
              clone,
              {
                navbar: false,
                navbars: [
                  {
                    position: 'top',
                    content: [`<a href="/">${settings.site.name}</a>`]
                  }
                ],
                slidingSubmenus: false,
                offCanvas: {
                  position: 'right'
                }
              },
              {
                classNames: {
                  selected: 'menu-item--active'
                },
                menu: {
                  insertMethod: 'append'
                },
                offCanvas: {
                  page: {
                    selector: '.dialog-off-canvas-main-canvas'
                  }
                }
              }
            )

            this.openMenu = e => {
              e.preventDefault()
              if ('api' in Drupal.behaviors.AutryHamburger) {
                Drupal.behaviors.AutryHamburger.api.open()
              }
            }

            this.api = this.mmenu.API

            this.api.bind('open:before', () => {
              trigger.setAttribute('aria-expanded', true)
            })
            this.api.bind('close:before', () => {
              trigger.setAttribute('aria-expanded', false)
            })
          } else {
            console.error('#block-sitemap', block)
          }
        },
        match: () => {
          trigger.addEventListener('click', this.openMenu)
        },
        unmatch: () => {
          if (this.api) {
            this.api.close()
          }
          trigger.removeEventListener('click', this.openMenu)
        }
      })
    })
  }
  // detach: function (context, settings, trigger) {
  //   console.log('detach')
  // }
}
